// JS-Spiegelung von styles/tokens.css für ApexCharts (kann keine CSS-Variablen lesen).
// Beide Dateien immer gemeinsam ändern. Alle Familien nehmen ihre Töne aus CHART_COLORS.
//
// Regel: Innerhalb einer Seite steht keine Farbe für zwei Dinge.
//   Schaltungstyp → Digital, Print · Kanal → Übersicht (Timeline, Matrix) und Seiten-Icons ·
//   Status → Print · Kennzahl → Diagrammserien (E-Mail, Traffic).

// Diagramm-Farbfamilie: gleiche Helligkeit und Sättigung je Ton, abgestimmt auf die
// Icon- und Lozenge-Töne in ads.css (--calm-*), damit Diagramme einheitlich wirken.
export const CHART_COLORS = {
  blue: '#2A6F95',
  teal: '#3E9A8D',
  indigo: '#7A76C6',
  violet: '#9B6FC4',
  pink: '#D06C9F',
  green: '#4FA66A',
  olive: '#94A84E',
  gray: '#8A8D93',
  ink: '#505258'
};

// Familie 1 – Schaltungstyp: Blau / Lila / Pink. Zwei Stufen für Diagramme mit zwei Serien
// (Digital: Impressions/Klicks): hell für die große Menge, dunkel (= Icon-Ton --calm-* in ads.css)
// für die kleine. Einfarbige Flächen (Kalender, Legende) nutzen --mb-placement-* in tokens.css.
export const PLACEMENT_SHADES = {
  intern: { light: '#8CC3DB', dark: '#23799D' },
  konzern: { light: '#C3A6E0', dark: '#7A4BA6' },
  gegengeschaeft: { light: '#E9A9C9', dark: '#A8366F' }
};

export function placementShades(code) {
  return PLACEMENT_SHADES[code] || { light: CHART_COLORS.gray, dark: CHART_COLORS.ink };
}

// Familie 2 – Kanal
// Blau, Lila und Pink sind für Schaltungstypen reserviert (beide stehen auf der Übersicht).
export const CHANNEL_COLORS = {
  digital: CHART_COLORS.teal,
  social: CHART_COLORS.indigo,
  email: CHART_COLORS.green,
  traffic: CHART_COLORS.olive,
  print: CHART_COLORS.ink
};

// Familie 3 – Status: nur CSS (tokens.css, --mb-status-*), passend zu den Lozenges.

// Lozenge-Ton je Status (StatusLozenge.vue)
export const STATUS_TONES = {
  geplant: 'default',
  angefragt: 'discovery',
  bestaetigt: 'information',
  erschienen: 'success',
  verschoben: 'warning',
  storniert: 'danger'
};

// Familie 4 – Kennzahl: Töne der Diagramm-Familie, erste Farbe = primäre Serie
export const METRIC_COLORS = [CHART_COLORS.blue, CHART_COLORS.green, CHART_COLORS.violet, CHART_COLORS.gray];

// Plattformfarben (nur Social-Seite): aus der Diagramm-Familie statt Netzwerk-Markenfarben.
export const PLATFORM_COLORS = {
  linkedin: CHART_COLORS.blue,
  xing: CHART_COLORS.teal,
  facebook: CHART_COLORS.indigo,
  instagram: CHART_COLORS.pink,
  youtube: CHART_COLORS.violet,
  pinterest: CHART_COLORS.green,
  tiktok: CHART_COLORS.ink,
  x: CHART_COLORS.gray,
  twitter: CHART_COLORS.gray
};

export function platformColor(name) {
  const key = String(name || '').trim().toLowerCase();
  return PLATFORM_COLORS[key] || METRIC_COLORS[1];
}
